module.exports = __webpack_public_path__ + "static/media/banner-mobile.7db8283d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner-mobile.webp
// module id = 272
// module chunks = 0